/* eslint-disable unicorn/numeric-separators-style */

import { StoryData } from '@storyblok/react'
import { HomeStoryContent } from '../../types/home-story-content'

export const homeStoryFallback: StoryData<HomeStoryContent> = {
  name: 'Home',
  created_at: '2022-08-26T15:24:13.017Z',
  published_at: '2026-10-02T16:08:03.206Z',
  id: 181087593,
  uuid: 'e3977607-836f-42c1-b1cb-89b9d1aa2743',
  content: {
    usp: [
      {
        _uid: '35898337-35a6-4ea0-aa73-aa39b8a1f180',
        icon: 'CinchCareServicingIcon',
        link: {
          id: '',
          url: 'https://www.cinch.co.uk/servicing',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: 'https://www.cinch.co.uk/servicing',
        },
        text: 'Get a faff-free service or MOT at 100+ locations - all cars welcome',
        title: 'Book a service or MOT',
        component: 'HomeUspSlide',
      },
      {
        _uid: '83452c26-9b27-4f6d-a05f-7f6688b493c1',
        icon: 'SmartPhoneIcon',
        link: {
          id: '',
          url: '/app',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: '/app',
        },
        text: 'Browse, shortlist and compare cars, then buy your favourite in a tap and a swipe',
        title: 'Download our app',
        component: 'HomeUspSlide',
      },
      {
        _uid: 'f5ad17e6-c6ba-4c77-af3e-6691c48e9eb1',
        icon: 'SearchIcon',
        link: {
          id: '',
          url: 'https://www.cinch.co.uk/reviews',
          linktype: 'url',
          fieldtype: 'multilink',
          cached_url: 'https://www.cinch.co.uk/reviews',
        },
        text: 'Get help choosing your next motor with our road-tested car reviews',
        title: 'Read our car reviews',
        component: 'HomeUspSlide',
      },
    ],
    _uid: '97440a25-fa55-4494-b617-667b10e8b43c',
    herov2: [
      {
        _uid: '044581c6-7757-4826-8c3f-2ca374ee1abd',
        component: 'HomeHeroV2',
        rightSideContent: [
          {
            _uid: 'dc7c673a-00a3-4256-9639-b26804a3986a',
            slides: [
              {
                cta: [
                  {
                    url: 'https://www.cinch.co.uk/used-cars?financeType=any',
                    _uid: 'ab02b81b-3548-44dc-9a8a-e08cd0026551',
                    type: 'primary',
                    label: 'Shop now',
                    component: 'CtaButton',
                  },
                ],
                _uid: '61286dac-8be1-4b75-8650-f1472cac56e8',
                image: {
                  id: 216101897942294,
                  alt: 'Man in a denim shirt and dark pants lies on a turquoise surface, holding a smartphone displaying a purple screen with the word "enjoy."',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/615x257/9ee1a24139/750x257-web-img_rylan.png',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'Man in a denim shirt and dark pants lies on a turquoise surface, holding a smartphone displaying a purple screen with the word "enjoy."',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Forget the faff.\ncinch it.',
                component: 'HomeHeroCard',
                subheading: '1000s of cars to choose from',
                campaignName: 'Rylan FTF',
              },
              {
                cta: [
                  {
                    url: '/used-cars?financeType=any&toPrice=200',
                    _uid: '69a875c7-8b7f-4a12-bbb4-82b9593b39d3',
                    type: 'primary',
                    label: "See what's available",
                    component: 'CtaButton',
                  },
                ],
                _uid: '5d99177f-595b-4e26-9c44-ea8b0c469258',
                image: {
                  id: 201144682394870,
                  alt: 'Three cars displayed: a red car on the left, a blue car in the center, and a white car on the right, all with the "cinch" logo.',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/600x250/62900f4ef7/cin60081_homepage-600x250-199.png',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'Three cars displayed: a red car on the left, a blue car in the center, and a white car on the right, all with the "cinch" logo.',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: '1000s of cars for\nunder £199 a month',
                component: 'HomeHeroCard',
                subheading: '',
                campaignName: '199 Message',
              },
              {
                cta: [
                  {
                    url: 'https://www.cinch.co.uk/car-finance',
                    _uid: '2c856474-6284-4b25-bc3f-9a5b1ed0eb8b',
                    type: 'primary',
                    label: 'Get an instant quote',
                    component: 'CtaButton',
                  },
                ],
                _uid: '34d03757-aa4a-408f-bb31-205c2dd99f0e',
                image: {
                  id: 203779763919702,
                  alt: 'Six cars of different colors displayed, each with a green checklist calendar icon in the background.',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/600x250/b2e3ccab08/cin60081_homepage-current-old-formathomepage-600x250-finance.png',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'Six cars of different colors displayed, each with a green checklist calendar icon in the background.',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Flexible finance to\nsuit all budgets   ',
                component: 'HomeHeroCard',
                subheading: 'Apply online, 24/7',
                campaignName: 'Flexible Finance',
              },
              {
                cta: [
                  {
                    url: 'used-cars?tags=cars-on-offer',
                    _uid: 'fa154c80-bf15-4809-872c-b12343419e6b',
                    type: 'primary',
                    label: 'View cars on offer',
                    component: 'CtaButton',
                  },
                ],
                _uid: '0a904da5-5432-4db7-a02c-c8634b6e7c4a',
                image: {
                  id: 219956285931353,
                  alt: 'A green car and a blue car are placed against a black background, adorned with orange, leaf-shaped designs.',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/1200x500/1475b56152/cinchautumn-website-fy27-q2-600x250.png',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'A green car and a blue car are placed against a black background, adorned with orange, leaf-shaped designs.',
                    size: '1200x500',
                  },
                  is_external_url: false,
                },
                heading: 'Autumn price drop',
                component: 'HomeHeroCard',
                subheading: '£250-£1000 off over \n1000 selected cars',
                campaignName: 'FY27 Q2 autumn price reductions',
              },
              {
                cta: [
                  {
                    url: '/servicing',
                    _uid: 'b056586f-3805-43dc-9f0c-77a4d8bb8008',
                    type: 'primary',
                    label: 'Book today',
                    component: 'CtaButton',
                  },
                ],
                _uid: '15b93220-25af-4942-af79-c0a068a9a955',
                image: {
                  id: 201142198273014,
                  alt: 'Colorful 3D elements on a gradient background include an up-arrow icon and a wrench, suggesting themes of improvement or tools.',
                  name: '',
                  focus: '',
                  title: '',
                  source: '',
                  filename:
                    'https://a.storyblok.com/f/143588/600x250/aaee19667c/cin60081_homepage-600x250-cs.png',
                  copyright: '',
                  fieldtype: 'asset',
                  meta_data: {
                    alt: 'Colorful 3D elements on a gradient background include an up-arrow icon and a wrench, suggesting themes of improvement or tools.',
                    title: '',
                    source: '',
                    copyright: '',
                  },
                  is_external_url: false,
                },
                heading: 'Faff-free servicing\nfrom £129.95',
                component: 'HomeHeroCard',
                subheading:
                  'Any make or model at \nlocations across the country',
                campaignName: 'cinchServicing​',
              },
            ],
            component: 'LoopingCarousel',
            shouldLoop: true,
            slideSpeedInSeconds: '6',
          },
        ],
        isHeroPromotional: false,
      },
    ],
    partEx: [
      {
        _uid: 'c000a459-55b0-4572-8d43-2aee50858d5a',
        link: 'Find out more about part exchange',
        image: {
          id: 5667847,
          alt: 'a customer smiling in their car',
          name: '',
          focus: null,
          title: '',
          filename:
            'https://a.storyblok.com/f/143588/598x478/f9bf0c0356/part-ex-valuation-image.png',
          copyright: '',
          fieldtype: 'asset',
        },
        label: 'Enter your car registration',
        title: 'Part exchange?',
        ctaText: 'Start your free valuation',
        subtitle: 'Get a free, instant part-ex quote.',
        component: 'PartExSection',
        placeholder: 'E.g. A20FGG',
      },
    ],
    whyCinch: [
      {
        _uid: '8f2aa82e-bddb-4f8b-bb8d-a82d218af4b9',
        cards: [
          {
            _uid: 'ecf148b3-c22a-43c0-a218-0838f9a9c65d',
            body: {
              type: 'doc',
              attrs: {
                backgroundColor: null,
              },
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'With thousands of ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'cars',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/used-cars',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' all in one place, you’re sure to find your perfect one. All used cars come with a 3-month warranty and a minimum 6-month MOT for total peace of mind.',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            icon: 'vehicle-front',
            name: 'cars',
            title: 'Great value, high-quality used cars',
            component: 'WhyCinchCard',
          },
          {
            _uid: '805c8891-c1e1-4473-af1c-878283d7307a',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Buy outright or spread the cost with helpful ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'finance',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-finance',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' options. You can ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'part exchange',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/part-exchange',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' and use the value of your old car to help pay for your new one.  ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            icon: 'calculator',
            name: 'finance',
            title: 'Choose how you pay',
            component: 'WhyCinchCard',
          },
          {
            _uid: 'd66d275e-db99-409c-8668-ce859bd5b275',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  attrs: {
                    textAlign: null,
                  },
                  content: [
                    {
                      text: 'Choose ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'home delivery',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/delivery',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: ' or ',
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: 'collect',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: '/car-collections',
                            uuid: null,
                            anchor: null,
                            target: '_self',
                            linktype: 'url',
                          },
                        },
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                    {
                      text: " from 100+ convenient locations to pick up your used car – it's up to you.",
                      type: 'text',
                      marks: [
                        {
                          type: 'styled',
                          attrs: {
                            class: '',
                          },
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            icon: 'home-delivery',
            name: 'delivery',
            title: 'Delivery or collection available',
            component: 'WhyCinchCard',
          },
        ],
        image: {
          id: 226376155489055,
          alt: 'Smiling man with beard in denim shirt, arms crossed, inside a turquoise ring.',
          name: '',
          focus: '',
          title: '',
          source: '',
          filename:
            'https://a.storyblok.com/f/143588/365x414/867b5115de/cinchweb-rylan-2.png',
          copyright: '',
          fieldtype: 'asset',
          meta_data: {
            alt: 'Smiling man with beard in denim shirt, arms crossed, inside a turquoise ring.',
            size: '365x414',
            title: '',
            source: '',
            copyright: '',
          },
          is_external_url: false,
        },
        title: 'Why cinch?',
        component: 'WhyCinchSection',
      },
    ],
    component: 'HomePage',
    carsCarousel: [
      {
        _uid: 'eae10720-b692-4ff4-85f5-1dc184d57001',
        title: 'Shop new cars',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '35000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: false,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [
          {
            _uid: 'f9efc638-6c61-48d3-bebc-5585325a6ee6',
            component: 'FinanceRepresentativeExample',
            creditAmount: '27863.92',
            onTheRoadPrice: '31723.92',
            customerDeposit: '2800',
            retailerDiscount: '1591.08',
            testDriveVoucher: '',
            representativeApr: '3.5',
            annualMileageLimit: '6000',
            totalAmountPayable: '34778',
            optionToPurchaseFee: '',
            totalInterestAmount: '3054.08',
            optionalFinalPayment: '15318',
            monthlyPaymentsAmount: '325',
            fixedAnnualInterestRate: '1.8',
            numberOfMonthlyPayments: '49',
            excessMileageChargeInPence: '14.9',
            financeDepositContribution: '1060',
          },
        ],
      },
    ],
    personalised: [
      {
        helpMeChoose: [
          {
            _uid: 'b492c62c-e9f6-4e94-b663-c953e7645897',
            body: 'Try our nifty Help Me Choose tool. Answer a few quick questions to find your perfect match.',
            image: {
              id: 6870271,
              alt: 'multiple cars',
              name: '',
              focus: null,
              title: '',
              filename:
                'https://a.storyblok.com/f/143588/2220x1440/eddc06cce0/help-me-choose.png',
              copyright: '',
              fieldtype: 'asset',
            },
            title: 'Not sure what you are looking for?',
            ctaText: 'Help Me Choose',
            heading: 'Narrow down your search',
            component: 'HelpMeChooseSection',
          },
        ],
        valuePropositions: [
          {
            _uid: '29ef7655-a0f6-4c02-9235-7927b346b2a6',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'All our used cars are ',
                      type: 'text',
                    },
                    {
                      text: 'carefully reconditioned',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'https://www.cinch.co.uk/car-inspection',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ', have a minimum 6-month MOT and come with a 3-month warranty.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            icon: 'shield',
            heading: 'cinch quality assured for used cars',
            component: 'ValuePropsCard',
          },
          {
            _uid: 'cc8c6ebe-85c2-4124-a70e-ffff4f88cbb7',
            body: {
              type: 'doc',
              content: [
                {
                  type: 'paragraph',
                  content: [
                    {
                      text: 'Get protection for what matters to you with ',
                      type: 'text',
                    },
                    {
                      text: 'cinchCover.',
                      type: 'text',
                      marks: [
                        {
                          type: 'link',
                          attrs: {
                            href: 'http://www.cinch.co.uk/car-care/cinch-cover',
                            uuid: null,
                            anchor: null,
                            target: null,
                            linktype: 'url',
                          },
                        },
                      ],
                    },
                    {
                      text: ' Keep your used car running and looking as it should, with protection against mechanical, electrical and cosmetic repairs.',
                      type: 'text',
                    },
                  ],
                },
              ],
            },
            icon: 'shield-heart',
            heading: 'Caring for your used car',
            component: 'ValuePropsCard',
          },
        ],
      },
    ],
    newCarsCarouselTab: [
      {
        _uid: '09d1d678-d3e9-4c89-8e68-3623d2bbcc78',
        title: 'Shop new cars',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '35000',
        component: 'CarsCarousel',
        priceFrom: '',
        disclaimer: 'Sold by our partner Marshall Motor Group',
        carsCondition: 'new',
        showMonthlyPrices: false,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [
          {
            _uid: 'f9efc638-6c61-48d3-bebc-5585325a6ee6',
            component: 'FinanceRepresentativeExample',
            creditAmount: '27863.92',
            onTheRoadPrice: '31723.92',
            customerDeposit: '2800',
            retailerDiscount: '1591.08',
            testDriveVoucher: '',
            representativeApr: '3.5',
            annualMileageLimit: '6000',
            totalAmountPayable: '34778',
            optionToPurchaseFee: '',
            totalInterestAmount: '3054.08',
            optionalFinalPayment: '15318',
            monthlyPaymentsAmount: '325',
            fixedAnnualInterestRate: '1.8',
            numberOfMonthlyPayments: '49',
            excessMileageChargeInPence: '14.9',
            financeDepositContribution: '1060',
          },
        ],
      },
    ],
    usedCarsCarouselTab: [
      {
        _uid: '5b7a9a83-da7c-4ae2-b126-c98e4c171b9b',
        title: '',
        sortBy: 'FIRST_PUBLISHED_DATE_DESC',
        priceTo: '20000',
        component: 'CarsCarousel',
        priceFrom: '10000',
        disclaimer: '',
        carsCondition: 'used',
        showMonthlyPrices: false,
        showOnlyCinchStock: false,
        financeRepresentativeExample: [],
      },
    ],
    previewPersonalisedContent: false,
  },
  slug: 'home',
  full_slug: 'home',
  sort_by_date: null,
  position: 50,
  tag_list: [],
  is_startpage: false,
  parent_id: 0,
  meta_data: null,
  group_id: '837246ae-690f-4e5c-9c54-002f7f2da6bf',
  first_published_at: '2022-08-26T15:28:52.094Z',
  lang: 'default',
  alternates: [],
}
